import { getPreferredCompsSection } from "./storage";

export function getModuleUrl(module) {
  const preferredCompsSection = getPreferredCompsSection();
  return module.key === "comps" && preferredCompsSection !== "comps"
    ? `${module.url}/${preferredCompsSection}`
    : module.url;
}
